import { useCallback } from 'react';
import { useContent } from '../redux/reducer/content';
import { getTypeBySlotType } from '../utils/helpers/helpers';

export const prizeMap = {
  attempts: 'energy',
  money: 'coin',
  gacha_event_cash: 'charm',
  promocode: 'promocode',
  score: 'score',
  beauties: 'beauties',
};

export const prizeKeys = ['attempts', 'money', 'score', 'gacha_event_cash', 'promocode', 'beauties'];

export const usePrizeInfo = () => {
  const { slots } = useContent();

  const getPrizeValue = useCallback((prize) => {
    for (const key of prizeKeys) if (prize[key]) return prize[key];
    return 'none';
  }, []);

  const getPrizeType = useCallback(
    (prize) => {
      if (!slots) return;
      for (const key in prizeMap) if (prize[key]) return prizeMap[key];
      return getTypeBySlotType(slots.find((slot) => slot.system_name === prize?.shopItem?.slot)?.type);
    },
    [slots],
  );

  return { getPrizeType, getPrizeValue };
};
